const apiUrl = process.env.VUE_APP_API_URL;

export default {
  height: 400,
  menubar: false,
  plugins: ['image link imagetools table media lists'],
  media_live_embeds: true,
  media_alt_source: false,
  media_dimensions: false,
  media_filter_html: false,
  media_poster: false,
  toolbar: 'bold italic underline | alignleft aligncenter alignright alignjustify | forecolor backcolor casechange permanentpen formatpainter removeformat | numlist bullist checklist | image link | table',
  table_toolbar: "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
  file_picker_callback: function(cb, value, meta) {
    let input = document.createElement('input');

    input.setAttribute('type', 'file');

    switch(meta.filetype) {
      case 'image': input.setAttribute('accept', 'image/*'); break;
      case 'file': input.setAttribute('accept', '.xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf'); break;
      case 'media': input.setAttribute('accept', 'media_type'); break;
    }

    input.onchange = function () {
      var xhr, formData;
    
      xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', `${apiUrl}/news/upload?type=${meta.filetype}`);
      xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.getItem('PERSONNEL_ACCESS_TOKEN'))}`)

      xhr.onload = function() {
        let json;

        if (xhr.status < 200 || xhr.status >= 300) {
          cb('เกิดข้อผิดพลาด', { title: 'ERROR' });
          return;
        }

        json = JSON.parse(xhr.responseText);

        cb(json.location, { title: json.title });
      };          
    
      formData = new FormData();
      formData.append('file', input.files[0]);
    
      xhr.send(formData);    
    };

    input.click();
  }
}